import axios from 'axios';

import { LOAN_PROCESSING_API_ENDPOINT } from 'constants/api';

const loanProcessingAPI = axios.create({
  baseURL: LOAN_PROCESSING_API_ENDPOINT,
});

export default loanProcessingAPI;
